import { useQuery, useQueries, useMutation } from "@tanstack/react-query";
import { queryClient } from "@/shared/services/queryClient";
import {
  greenhouseBaysApi,
  type CreateGreenhouseBayRequest,
} from "../services/greenhouseBaysApi";

export const useBaysByGreenhouseId = (greenhouseId: string) => {
  return useQuery({
    queryKey: ["bays", greenhouseId],
    queryFn: () => greenhouseBaysApi.getBaysByGreenhouseId(greenhouseId),
    enabled: !!greenhouseId,
  });
};

export const useMultiGreenhouseBays = (greenhouseIds: string[]) => {
  return useQueries({
    queries: greenhouseIds.map((id) => ({
      queryKey: ["bays", id],
      queryFn: () => greenhouseBaysApi.getBaysByGreenhouseId(id),
      enabled: !!id,
    })),
  });
};

export const useBayById = (bayId: string) => {
  return useQuery({
    queryKey: ["bays", bayId],
    queryFn: () => greenhouseBaysApi.getBayById(bayId),
    enabled: !!bayId,
  });
};

export const useCreateBay = () => {
  return useMutation({
    mutationFn: (payload: CreateGreenhouseBayRequest) =>
      greenhouseBaysApi.createBay(payload),
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ["bays", data.greenhouseId] });
    },
  });
};

export const useUpdateBay = (bayId: string) => {
  return useMutation({
    mutationFn: (payload: CreateGreenhouseBayRequest) =>
      greenhouseBaysApi.updateBay(bayId, payload),
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ["bays", data.greenhouseId] });
      queryClient.invalidateQueries({ queryKey: ["bays", bayId] });
    },
  });
};

export const useDeleteBay = () => {
  return useMutation({
    mutationFn: (bayId: string) => greenhouseBaysApi.deleteBay(bayId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["bays"] });
    },
  });
};